// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vPuP","col":"styles_col__1pNXf","actions":"styles_actions__1s0_I","conflict":"styles_conflict__1Jrgy"};